import React from 'react';

import './header.scss';
import Lang from '../Lang';
import Menu from '../Menu';
import cv from '../../files/CV_Mikhail Zyryanov.pdf';

const menu = {
    en: {
        logo: 'CV  Mikhail Zyranau',
        download: 'Download PDF',
        label1: 'About',
        label2: 'Skills',
        label3: 'Portfolio',
    },
    ru: {
        logo: 'CV  Михаил Зырянов',
        download: 'Скачать PDF',
        label1: 'Общая информация',
        label2: 'Навыки',
        label3: 'Портфолио',
    },
};

const Header = ({ lang, switchLang, switchPage, page }) => {
    const { logo, download } = menu[lang];
    return (
        <header>
            <h1>{logo}</h1>
            <div>
                <a href={cv} download='CV_Mikhail_Zyryanov.pdf'>
                    {download}
                </a>
            </div>
            <Menu lang={lang} switchPage={switchPage} page={page} />
            <Lang switchLang={switchLang} />
        </header>
    );
};

export default Header;
